import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { updateCartWithSizeQuantities } from '../ducks/cart.duck';

const useToggleCart = () => {
  const dispatch = useDispatch();
  const updateCartWithSizeQuantitiesInProgressIds = useSelector(
    state => state.cart.updateCartWithSizeQuantitiesInProgressIds,
    shallowEqual
  );
  const updateCartWithSizeQuantitiesError = useSelector(
    state => state.cart.updateCartWithSizeQuantitiesError,
    shallowEqual
  );

  const updateCartWithSizeQuantitiesFunction = (providerId, listingId, orderedSizeWithQuantities) =>
    dispatch(updateCartWithSizeQuantities(providerId, listingId, orderedSizeWithQuantities));

  return {
    updateCartWithSizeQuantities: updateCartWithSizeQuantitiesFunction,
    updateCartWithSizeQuantitiesInProgress: updateCartWithSizeQuantitiesInProgressIds.length > 0,
    updateCartWithSizeQuantitiesError,
    updateCartWithSizeQuantitiesInProgressIds,
  };
};

export default useToggleCart;
